<template>
  <div class="c-result">
    <div class="c-head">
      <h3>{{ title }}</h3>
    </div>
    <Table :height="height" :columns="columns" :data="data"> </Table>
  </div>
</template>
<script>
export default {
  name: 'ksresult',
  props: {
    columns: {
      type: Array
    },
    data: {
      type: Array
    },
    title: {
      type: String
    },
    height: {
      type: String,
      default() {
        return '300'
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.c-result {
  position: relative;
  padding: 12px 20px;

  .c-head {
    text-align: center;
    padding: 12px 0;
  }
}
</style>
